import { CircularProgress, Typography } from "@mui/material";
import { Box } from "@mui/system";
import useStyles from "./styles";
import { useTheme } from "@emotion/react";

export default function CircularProgressWithLabel(params) {
  const { value = 0 } = params;
  const theme = useTheme();
  const styles = useStyles(theme);
  return (
    <Box sx={styles.containerComponent}>
      <CircularProgress
        variant={"determinate"}
        value={value * (5 / 3)}
        sx={{ color: "primary" }}
      />
      <Box sx={styles.containerValueProgress}>
        <Typography variant="caption" component="div" color="primary">
          {value <= 0 || value >= 60 ? 0 : `${Math.round(value)}`}
        </Typography>
      </Box>
    </Box>
  );
}
